import { Core } from '@strapi/strapi';
import { KoniBot } from "../../bot/koni-bot";
import {Telegraf} from "telegraf";
import {BotMessageTemplateType} from "../content-type/bot-message-template";

interface BotConfig {
  username: string;
  token: string;
  miniapp?: string;
}

// Issue-58 | Get bot configs from env variables TELEGRAM_BOT_TOKEN_0, TELEGRAM_BOT_USERNAME_0
// Issue-58 | Auto add more bot if get more env variables TELEGRAM_BOT_TOKEN_1, TELEGRAM_BOT_USERNAME_1
export function getBotConfigs() {
  const botConfigs: BotConfig[] = [];
  let i = 0;
  while (true) {
    const token = process.env[`TELEGRAM_BOT_TOKEN_${i}`];
    const username = process.env[`TELEGRAM_BOT_USERNAME_${i}`];
    const miniapp = process.env[`TELEGRAM_BOT_MINIAPP_${i}`];

    if (!token || !username) {
      break;
    }

    botConfigs.push({
      username,
      token,
      miniapp
    });

    i++;
  }

  return botConfigs;
}

const KoniBotService = ({ strapi }: { strapi: Core.Strapi }) => ({
  defaultBotName: '',
  _initBotMap: false,
  _botMap: {} as Record<string, KoniBot>,

  get botMap() {
    if (!this._initBotMap) {
      // Issue-58 | Init new bot and assign to the botMap with env variables
      // Issue-58 | Set default with the first bot in the botMap
      const configs = getBotConfigs();

      configs.forEach(({username, token, miniapp}) => {
        this._botMap[username] = new KoniBot(token, miniapp);

        if (!this.defaultBotName) {
          this.defaultBotName = username;
        }
      });

      this._initBotMap = true;
    }

    return this._botMap;
  },

  getBotHandler(name?: string) {
    // Issue-58 | Ensure registered bot exists
    const bot = this.botMap[name || this.defaultBotName];

    if (!bot) {
      throw new Error(`Bot ${name} not found`);
    }

    return bot;
  },

  getBot(name?: string): Telegraf {
    return this.getBotHandler(name).bot;
  },

  async launch() {
    // Issue-58 | launch all bot in botMap
    await strapi.plugin('telegram-bot').service<BotMessageTemplateType>('bot-message-template').renewCache();
    await Promise.all(Object.entries(this._botMap).map(([key, koniBot]) => {
      koniBot.launch();
      strapi.log.info(`Koni Bot launched ${key}`);
    }));
  },

  async stop() {
    // Issue-58 | stop all bot in botMap
    await Promise.all(Object.values(this._botMap).map(koniBot => koniBot.stop()));
    strapi.log.info('Koni Bot stopped');
  }
});

export type KoniBotServiceType = ReturnType<typeof KoniBotService>;

export default KoniBotService;
